import React, { useEffect, useState } from 'react';
import EventPopupModal from './../components/EventPopupModal.jsx'; 
import Hero from './../components/Hero.jsx';
import PlanStay from './../components/PlanStay.jsx'; 
import Dining from './../components/Dining.jsx'; 
import Food from './../components/Food.jsx'; 
import EventSlider from './../components/EventSlider.jsx'; 
import BurrowShowcase from './../components/BurrowShowcase.jsx'; 
import foxTextSplitter from './../assets/images/Splitters/foxTextSplitter.webp'

const Home = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem('seenEventPopup');
    if (!seen) {
      setShowPopup(true);
      sessionStorage.setItem('seenEventPopup', 'true');
    }
  }, []);

  const handleClose = () => setShowPopup(false);

  const handleBook = () => {
    setShowPopup(false);
    window.open('https://www.foxinn-stourton.co.uk/christmas');
  };

  return (
    <div>
        {showPopup && <EventPopupModal onClose={handleClose} onBook={handleBook} />}
        <Hero />
        <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
        </div>
        <EventSlider />        
        <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
        </div>
        <BurrowShowcase />
        <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
        </div>
        <Dining />
        <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
        </div>
        <Food />
        <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
        </div>
        <PlanStay />

    </div>
  )
}

export default Home